export default "__VITE_ASSET__a2e0a442__"